window.onload = () => {
  let selectedVideo;
  const videoLinks = document.querySelectorAll(".related-video__hover");
  for (let video of videoLinks) {
    video.addEventListener("click", () => {
      let oldVidId = document.querySelector(".youtube__selected-video").dataset.selectedId;
      let newVidId = video.dataset.videoId;
      if (newVidId)
        setNewVideo(newVidId, video.dataset.title, video.dataset.desc);
      // replaceRelated(newVidId, oldVidId);
    });
  }
};

const setNewVideo = (id, title, desc) => {
  selectedVideo = document.querySelector(".youtube__selected-video").dataset
    .videoId;
  document
    .querySelector(".youtube__selected-video iframe")
    .setAttribute("src", `https://www.youtube.com/embed/${id}`);
  document.querySelector(".youtube-selected__title").innerHTML = title;
  document.querySelector(".youtube-selected__desc").innerHTML = desc;
};

const replaceRelated = (newId, oldId) => {
  document.querySelector(`.related-video__block[data-video-id='${oldId}']`).classList.remove("hide");
  document.querySelector(".youtube__selected-video").setAttribute("data-selected-id", newId);
  document.querySelector(`.related-video__block[data-video-id='${newId}']`).classList.add("hide");
}